/**
 * BetterWild Homepage (ctr-hp) — carousels, before/after clipper, FAQ accordion
 */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function initCarousels(root) {
    var groupApi = {};

    root.querySelectorAll('[data-ctr-hp-carousel]').forEach(function (carousel) {
      if (carousel.dataset.ctrHpCarouselReady === '1') return;
      carousel.dataset.ctrHpCarouselReady = '1';

      var track = carousel.querySelector('[data-ctr-hp-carousel-track]');
      var slides = carousel.querySelectorAll('[data-ctr-hp-carousel-slide]');
      var prev = carousel.querySelector('[data-ctr-hp-carousel-prev]');
      var next = carousel.querySelector('[data-ctr-hp-carousel-next]');
      var dotsWrap = carousel.querySelector('[data-ctr-hp-carousel-dots]');
      if (!track || !slides.length) return;

      var index = 0;
      var dots = [];
      var group = carousel.getAttribute('data-ctr-hp-carousel-group');
      var looping = carousel.hasAttribute('data-ctr-hp-carousel-loop');
      var syncing = false;

      function updateControls() {
        var atStart = index <= 0;
        var atEnd = index >= slides.length - 1;

        if (prev) {
          var prevInactive = !looping && atStart;
          prev.classList.toggle('is-inactive', prevInactive);
          prev.classList.toggle('is-active', !prevInactive);
          prev.setAttribute('aria-disabled', prevInactive ? 'true' : 'false');
          prev.disabled = prevInactive;
        }

        if (next) {
          var nextInactive = !looping && atEnd;
          next.classList.toggle('is-inactive', nextInactive);
          next.classList.toggle('is-active', !nextInactive);
          next.setAttribute('aria-disabled', nextInactive ? 'true' : 'false');
          next.disabled = nextInactive;
        }

        dots.forEach(function (dot, di) {
          dot.classList.toggle('is-active', di === index);
          dot.setAttribute('aria-current', di === index ? 'true' : 'false');
        });
      }

      function goTo(i, fromSync, options) {
        if (looping) {
          index = ((i % slides.length) + slides.length) % slides.length;
        } else {
          index = Math.max(0, Math.min(slides.length - 1, i));
        }

        var slide = slides[index];
        var instant = fromSync || (options && options.instant);
        track.scrollTo({
          left: slide.offsetLeft - track.offsetLeft,
          behavior: instant ? 'auto' : 'smooth',
        });
        updateControls();

        if (!fromSync && group && groupApi[group]) {
          syncing = true;
          groupApi[group].forEach(function (api) {
            if (api.el !== carousel) api.goTo(index, true);
          });
          syncing = false;
        }
      }

      if (dotsWrap) {
        slides.forEach(function (_, i) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'ctr-hp-carousel__dot' + (i === 0 ? ' is-active' : '');
          dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
          if (i === 0) dot.setAttribute('aria-current', 'true');
          dot.addEventListener('click', function () {
            goTo(i);
          });
          dotsWrap.appendChild(dot);
          dots.push(dot);
        });
      }

      if (prev) {
        prev.addEventListener('click', function () {
          if (prev.classList.contains('is-inactive')) return;
          goTo(index - 1);
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          if (next.classList.contains('is-inactive')) return;
          goTo(index + 1);
        });
      }

      var scrollTimer;
      track.addEventListener('scroll', function () {
        if (syncing) return;
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function () {
          var closest = 0;
          var best = Infinity;
          slides.forEach(function (slide, i) {
            var dist = Math.abs(slide.offsetLeft - track.scrollLeft - track.offsetLeft);
            if (dist < best) {
              best = dist;
              closest = i;
            }
          });
          if (closest === index) {
            updateControls();
            return;
          }
          index = closest;
          updateControls();
          if (group && groupApi[group]) {
            syncing = true;
            groupApi[group].forEach(function (api) {
              if (api.el !== carousel) api.goTo(index, true);
            });
            syncing = false;
          }
        }, 60);
      });

      updateControls();

      carousel.ctrHpCarousel = {
        goTo: goTo,
        getIndex: function () {
          return index;
        },
        getSlides: function () {
          return slides;
        },
      };

      if (group) {
        if (!groupApi[group]) groupApi[group] = [];
        groupApi[group].push({ el: carousel, goTo: goTo });
      }
    });
  }

  function initCompare(root) {
    root.querySelectorAll('[data-ctr-hp-compare]').forEach(function (compare) {
      if (compare.dataset.ctrHpCompareReady === '1') return;
      compare.dataset.ctrHpCompareReady = '1';

      var clipper = compare.querySelector('[data-ctr-hp-compare-clipper]');
      var afterMedia = compare.querySelector('[data-ctr-hp-compare-after-media]');
      var handle = compare.querySelector('[data-ctr-hp-compare-handle]');
      var range = compare.querySelector('[data-ctr-hp-compare-range]');
      if (!clipper || !handle || !range) return;

      function setPos(pct) {
        var value = Math.max(0, Math.min(100, pct));
        var width = compare.clientWidth || compare.getBoundingClientRect().width;

        // Overflow clip (reliable with <video>) — left = before, right = after
        clipper.style.left = value + '%';
        clipper.style.right = '0';
        clipper.style.width = 'auto';
        clipper.style.clipPath = 'none';

        if (afterMedia && width) {
          afterMedia.style.width = width + 'px';
          afterMedia.style.height = '100%';
          afterMedia.style.left = -width * (value / 100) + 'px';
          afterMedia.style.right = 'auto';
        }

        handle.style.left = value + '%';
        range.value = String(value);
      }

      setPos(Number(range.value) || 50);

      range.addEventListener('input', function () {
        setPos(Number(range.value));
      });

      var dragging = false;

      function fromClientX(clientX) {
        var rect = compare.getBoundingClientRect();
        if (!rect.width) return;
        setPos(((clientX - rect.left) / rect.width) * 100);
      }

      handle.addEventListener('pointerdown', function (e) {
        e.preventDefault();
        e.stopPropagation();
        dragging = true;
        handle.setPointerCapture(e.pointerId);
        fromClientX(e.clientX);
      });
      handle.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        fromClientX(e.clientX);
      });
      handle.addEventListener('pointerup', function () {
        dragging = false;
      });
      handle.addEventListener('pointercancel', function () {
        dragging = false;
      });

      compare.addEventListener('pointerdown', function (e) {
        if (e.target.closest('[data-ctr-hp-video-toggle]')) return;
        if (e.target.closest('[data-ctr-hp-compare-handle]')) return;
        dragging = true;
        fromClientX(e.clientX);
      });
      compare.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        if (e.target.closest('[data-ctr-hp-video-toggle]')) return;
        fromClientX(e.clientX);
      });
      compare.addEventListener('pointerup', function () {
        dragging = false;
      });
      compare.addEventListener('pointercancel', function () {
        dragging = false;
      });

      window.addEventListener(
        'resize',
        function () {
          setPos(Number(range.value) || 50);
        },
        { passive: true }
      );
    });
  }

  function syncVideoToggle(btn, video) {
    var paused = video.paused;
    btn.classList.toggle('is-paused', paused);
    btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
    btn.setAttribute('aria-label', paused ? 'Play video' : 'Pause video');
  }

  function initVideoToggles(root) {
    root.querySelectorAll('[data-ctr-hp-video-toggle]').forEach(function (btn) {
      if (btn.dataset.ctrHpVideoReady === '1') return;
      btn.dataset.ctrHpVideoReady = '1';

      var host =
        btn.closest('.ctr-hp-compare__media') ||
        btn.closest('.ctr-hp-need-finder__split-half') ||
        btn.closest('.ctr-ar-reviews__media') ||
        btn.parentElement;
      var video = host && host.querySelector('video');
      if (!video) {
        btn.hidden = true;
        return;
      }

      syncVideoToggle(btn, video);

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (video.paused) {
          var playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(function () {});
          }
        } else {
          video.pause();
        }
        syncVideoToggle(btn, video);
      });

      video.addEventListener('play', function () {
        syncVideoToggle(btn, video);
      });
      video.addEventListener('pause', function () {
        syncVideoToggle(btn, video);
      });
    });
  }

  function initFaq(root) {
    root.querySelectorAll('[data-ctr-hp-faq]').forEach(function (list) {
      if (list.dataset.ctrHpFaqReady === '1') return;
      list.dataset.ctrHpFaqReady = '1';

      function closeAll() {
        list.querySelectorAll('[data-ctr-hp-faq-item]').forEach(function (sib) {
          sib.classList.remove('is-active');
          var btn = sib.querySelector('[data-ctr-hp-faq-trigger]');
          if (btn) btn.setAttribute('aria-expanded', 'false');
          var body = sib.querySelector('[data-ctr-hp-faq-body]');
          if (body) body.style.height = '0px';
        });
      }

      function openItem(item) {
        if (!item || !list.contains(item)) return;
        closeAll();
        item.classList.add('is-active');
        var trigger = item.querySelector('[data-ctr-hp-faq-trigger]');
        if (trigger) trigger.setAttribute('aria-expanded', 'true');
        var body = item.querySelector('[data-ctr-hp-faq-body]');
        if (body) body.style.height = body.scrollHeight + 'px';
      }

      list.querySelectorAll('[data-ctr-hp-faq-item].is-active [data-ctr-hp-faq-body]').forEach(function (body) {
        body.style.height = body.scrollHeight + 'px';
      });

      list.addEventListener('click', function (e) {
        var trigger = e.target.closest('[data-ctr-hp-faq-trigger]');
        if (!trigger || !list.contains(trigger)) return;

        e.preventDefault();
        var item = trigger.closest('[data-ctr-hp-faq-item]');
        if (!item) return;

        if (item.classList.contains('is-active')) {
          closeAll();
          return;
        }
        openItem(item);
      });

      list.ctrHpFaq = {
        open: openItem,
        closeAll: closeAll,
      };
    });
  }

  function initNeedTabs(root) {
    root.querySelectorAll('[data-ctr-hp-need-tabs]').forEach(function (wrap) {
      if (wrap.dataset.ctrHpNeedReady === '1') return;
      wrap.dataset.ctrHpNeedReady = '1';

      var tabs = wrap.querySelectorAll('[data-ctr-hp-need-tab]');
      var panels = wrap.querySelectorAll('[data-ctr-hp-need-panel]');
      if (!tabs.length || !panels.length) return;

      function activate(key) {
        tabs.forEach(function (tab) {
          var on = tab.getAttribute('data-ctr-hp-need-tab') === key;
          tab.classList.toggle('is-active', on);
          tab.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panels.forEach(function (panel) {
          var on = panel.getAttribute('data-ctr-hp-need-panel') === key;
          panel.classList.toggle('is-active', on);
          panel.hidden = !on;
        });
      }

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          activate(tab.getAttribute('data-ctr-hp-need-tab'));
        });
      });

      var initial = tabs[0] && tabs[0].getAttribute('data-ctr-hp-need-tab');
      if (initial) activate(initial);

      wrap.ctrHpNeedTabs = {
        activate: activate,
      };
    });
  }

  function initAll(root) {
    initCarousels(root);
    initCompare(root);
    initVideoToggles(root);
    initFaq(root);
    initNeedTabs(root);
  }

  function scrollBlockIntoView(el) {
    if (!el || typeof el.scrollIntoView !== 'function') return;
    try {
      el.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
    } catch (err) {
      el.scrollIntoView(true);
    }
  }

  function onBlockSelect(event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var slide =
      target.matches && target.matches('[data-ctr-hp-carousel-slide]')
        ? target
        : target.closest('[data-ctr-hp-carousel-slide]');
    if (slide) {
      var carousel = slide.closest('[data-ctr-hp-carousel]');
      if (carousel && carousel.ctrHpCarousel) {
        var slides = carousel.querySelectorAll('[data-ctr-hp-carousel-slide]');
        var index = Array.prototype.indexOf.call(slides, slide);
        if (index >= 0) {
          carousel.ctrHpCarousel.goTo(index, false, { instant: true });
        }
      }
      scrollBlockIntoView(slide);
      return;
    }

    var faqItem =
      target.matches && target.matches('[data-ctr-hp-faq-item]')
        ? target
        : target.closest('[data-ctr-hp-faq-item]');
    if (faqItem) {
      var faqList = faqItem.closest('[data-ctr-hp-faq]');
      if (faqList && faqList.ctrHpFaq) {
        faqList.ctrHpFaq.open(faqItem);
      }
      scrollBlockIntoView(faqItem);
      return;
    }

    var needPanel =
      target.matches && target.matches('[data-ctr-hp-need-panel]')
        ? target
        : target.closest('[data-ctr-hp-need-panel]');
    if (needPanel) {
      var needWrap = needPanel.closest('[data-ctr-hp-need-tabs]');
      var key = needPanel.getAttribute('data-ctr-hp-need-panel');
      if (needWrap && needWrap.ctrHpNeedTabs && key) {
        needWrap.ctrHpNeedTabs.activate(key);
      }
      scrollBlockIntoView(needPanel);
    }
  }

  function onSectionLoad(event) {
    var section = event.target;
    if (!section) return;
    initAll(section);
  }

  ready(function () {
    initAll(document);

    document.addEventListener('shopify:block:select', onBlockSelect);
    document.addEventListener('shopify:section:load', onSectionLoad);
  });
})();
